<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow>
      <CCol md="12">
        <CCardGroup>
          <CCard class="p-4">
            <CCardBody>
              <CForm @submit.prevent="login" style="width: 300px">
                <h1>Login</h1>
                <p class="text-muted">Sign In to your account</p>

                <b-row>
                  <b-input-group>
                    <template #prepend>
                      <b-input-group-text>
                        <CIcon name="cil-user" />
                      </b-input-group-text>
                    </template>
                    <b-form-input
                      id="input-account"
                      v-model="$v.username.$model"
                      :state="$v.username.$dirty ? !$v.username.$error : null"
                      aria-describedby="input-live-help input-live-feedback2"
                      placeholder="Nhập tài khoản"
                      trim
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-live-feedback2">
                      Vui lòng nhập tài khoản
                    </b-form-invalid-feedback>
                    <!-- This will only be shown if the preceding input has an invalid state -->
                  </b-input-group>
                </b-row>

                <b-row class="mt-3">
                  <b-input-group>
                    <template #prepend>
                      <b-input-group-text>
                        <CIcon name="cil-lock-locked" />
                      </b-input-group-text>
                    </template>
                    <b-form-input
                      id="input-live"
                      type="password"
                      v-model="$v.password.$model"
                      :state="$v.password.$dirty ? !$v.password.$error : null"
                      aria-describedby="input-live-help input-live-feedback"
                      placeholder="Nhập mật khẩu"
                      trim
                    ></b-form-input>
                    <b-form-invalid-feedback
                      id="input-live-feedback"
                      v-if="!$v.password.$model"
                    >
                      Vui lòng nhập mật khẩu
                    </b-form-invalid-feedback>

                    <b-form-invalid-feedback
                      id="input-live-feedback3"
                      v-if="$v.password.$model && this.errorMsg"
                    >
                      Tài khoản hoặc mật khẩu không đúng
                    </b-form-invalid-feedback>
                    <!-- This will only be shown if the preceding input has an invalid state -->
                  </b-input-group>
                </b-row>
                <b-row>
                  <span v-if="this.errorMsg" class="invalid-feedback-pass">
                    Tài khoản hoặc mật khẩu không đúng
                  </span>
                </b-row>
                <!-- <b-row>
                  <b-col md="6">
                    <b-input-group class="mt-3">
                      <template #prepend>
                        <b-input-group-text>
                          <CIcon name="cil-user" />
                        </b-input-group-text>
                      </template>
                      <b-form-input
                        type="text"
                        aria-describedby="codeFeedback"
                        v-model="$v.username.$model"
                        :state="$v.username.$dirty ? !$v.username.$error : null"
                      >
                      </b-form-input>
                      <b-form-invalid-feedback id="codeFeedback">
                        Vui lòng nhập tiêu đề bài viết
                      </b-form-invalid-feedback>
                    </b-input-group>
                  </b-col>
                </b-row> -->

                <!-- <CInput
                  class="mt-3"
                  placeholder="Password"
                  v-model="password"
                  type="password"
                  autocomplete="curent-password"
                >
                  <template #prepend-content>
                    <CIcon name="cil-lock-locked" />
                  </template>
                </CInput> -->
                <CRow class="mt-3">
                  <CCol col="6" class="text-left">
                    <CButton color="primary" class="px-4" type="submit">
                      Đăng nhập
                    </CButton>
                  </CCol>
                  <CCol col="6" class="text-right">
                    <CButton color="link" class="px-0"
                      >Forgot password?</CButton
                    >
                    <CButton color="link" class="d-md-none"
                      >Register now!</CButton
                    >
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  name: "Login",
  mixins: [validationMixin],
  data() {
    return {
      username: null,
      username2: null,
      password: null,
      errorMsg: null,
      name: "",
    };
  },
  computed: {
    nameState() {
      if (this.name === null) {
        return null;
      } else {
        return this.name.length > 2 ? true : false;
      }
    },
  },
  validations: {
    username: {
      required,
    },
    password: {
      required,
    },
  },
  methods: {
    login() {
      var vm = this;
      vm.$v.$touch();
      if (!vm.$v.$invalid) {
        vm.errorMsg = null;
        vm.$store
          .dispatch("authenticate", {
            username: this.username,
            password: this.password,
          })
          .done(() => vm.$router.push({ path: "/" }))
          .fail(function (errors) {
            if (errors.responseJSON && errors.responseJSON.error_description) {
              vm.errorMsg = errors.responseJSON.error_description;
            } else {
              vm.errorMsg = errors.statusText;
            }
          });
      }
    },
  },
};
</script>
<style scoped>
.invalid-feedback-pass {
  /* width: ; */
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #e55353;
}
</style>